<template>
  <teleport to="#app">
    <transition @afterLeave="afterClose">
      <div ref="modal" v-if="isOpen" class="m-modal" role="dialog" :aria-modal="isOpen ? 'true' : 'false'" tabindex="-1">
        <div class="m-modal__inner">
          <button @click="close" type="button" class="m-modal__close">
            <svg aria-hidden="true">
              <use :xlink:href="$root.spritePath + '#close'"/>
            </svg>
          </button>
          <slot></slot>
        </div>
        <button @click="close" type="button" class="m-modal__backdrop" tabindex="-1"></button>
      </div>
    </transition>
  </teleport>
</template>

<script>
import { createFocusTrap } from 'focus-trap'
import { useCookiebot } from '../js/cookiebot'

const cookiebot = useCookiebot();

export default {
  data: () => ({
    isOpen: false,
    referrerTarget: null,
    trap: null,
    cookiebot: cookiebot,
  }),

  methods: {
    async open(referrerTarget) {
      this.isOpen = true;
      this.referrerTarget = referrerTarget;

      window.addEventListener('keydown', this.handleEscape, true)

      await this.$nextTick()

      if (this.$refs.modal) {
        this.trap = createFocusTrap([this.$refs.modal]).activate()
      }
    },

    close() {
      this.isOpen = false
      this.cookiebot.hide()

      window.removeEventListener('keydown', this.handleEscape, true)

      if (this.trap) {
        this.trap.deactivate()
      }
    },

    toggle() {
      this.isOpen ? this.close() : this.open();
    },

    afterClose() {
      if (this.referrerTarget) {
        this.referrerTarget.focus();
      }
    },

    handleEscape(e) {
      e.key === 'Esc' || e.key === 'Escape' ? close() : null
    },
  },
}
</script>
